var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}]},[_c('b',[_vm._v(_vm._s(_vm.message))]),_c('b-progress',{attrs:{"striped":"","animated":"","value":_vm.value,"height":"3px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }